import { unstable_memoTheme } from '@mui/system';
const memoTheme = unstable_memoTheme;
export default memoTheme;